export default "__VITE_ASSET__CY17U3PO__"